import 'typeface-roboto';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom/client";
import * as serviceWorker from './serviceWorkerRegistration';
import { Provider } from 'react-redux';
// import store from './store/storeConfig';
import './scss/_custom.scss';
import './scss/registration.scss';
import './scss/contentLibrary.scss';
import './scss/screenShot.scss';
import './scss/refund.scss';
import Router from './router/router';
import './scss/style.scss';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.css';
import store from 'Stores/store';


// Init the API service

// Init rest API client

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<Provider store={store}>{Router}</Provider>);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
